/**
 * Common dependencies
 */
import './common_dependencies';
import qs from 'qs';
import { tagsPath, curatedListPath } from '../../../utilities/api_relative_paths';
import { createQueryString } from '../../../utilities/utilities';
import {
  addConsultantTagging,
  queryTaggings,
  removeTaggings,
} from '../../../utilities/angular/tags_helper';
/**
 * App models
 */
import './models/logged_search.model.js';
/**
 * Services
 */
import '../../../../../lib/assets/javascripts/devex/angular/models/alert_handling_service';
/**
 * Bookmarked Searches
 */
import '../../../../../lib/assets/javascripts/devex/angular/models/bookmarked-search';
import '../../../../assets/javascripts/shared/angular/bookmarked_searches_controller';
import '../../../../../lib/assets/javascripts/devex/angular/filters/bookmarked_search_ownership';
import '../../../../../lib/assets/javascripts/devex/angular/filters/my_alert';
/**
 * Webpack Components
 */
import './components/discover_similar_profile/discover_similar_profile.module';
import './components/admin_only_download_ids/admin_only_download_ids.module';
import '../../../components/consultant_search_result/consultant_search_result.module';
import './components/sidebar/sidebar.module';
import './components/recruiter_tools/recruiter_tools.module';
/**
 * UI Bootstrap dropdown
 */
import dropdown from 'angular-ui-bootstrap/src/dropdown';
/**
 * Styles
 */
import '../../styles/recruiter_search_app_styles.scss';

const dependencies = [
  'devex.search',
  'ui.bootstrap.tpls',
  'ui.bootstrap.typeahead',
  'ui.bootstrap.tooltip',
  'directives.paginationInfo',
  'directives.uiSelect',
  'directives.pagination',
  'directives.favorites',
  'services.ErrorReportingService',
  'components.recruiterFolderSelect',
  'components.recruiterNotesList',
  'components.recruiterContactButton',
  'peopleSearch.components.discoverSimilarProfile',
  'peopleSearch.components.adminOnlyDownloadIds',
  'components.consultantSearchResult',
  'components.sidebar',
  'components.recruiterToolsComponent',
  'ngSanitize',
  'ngAnimate',
  'recruiterSearch.models.loggedSearch',
  'filters.lists',
  'filters.daysAgo',
  'services.RoutesService',
  'rzSlider',
  dropdown,
  'ui.bootstrap.modal',
  'models.bookmarkedSearch',
  'bookmarkedSearches',
  'models.alertHandlingService',
];

angular.module('peopleSearch', dependencies).controller('peopleSearchController', [
  '$scope',
  '$http',
  '$timeout',
  'SearchJS',
  'RoutesService',
  'LoggedSearch',
  function ($scope, $http, $timeout, SearchJS, Routes, LoggedSearch) {
    /**
     * Creates functions and variables used to generate the Sort by filter
     *
     * @returns {undefined}
     */

    const defineSortingFilterLogic = () => {
      $scope.sortingOptions = {
        isDropdownExpanded: false,
        updatedAtFilterValue: 'last_profile_update',
      };

      /**
       * Set as SearchJS sorting param updated_at
       *
       * @returns {undefined}
       */
      $scope.setUpdatedAtFilter = () => {
        const field = $scope.sortingOptions.updatedAtFilterValue;
        $scope.search.sorting.setParams({ sorting: { field } });
      };

      /**
       * Sets updated_at as sorting param and run new Search
       *
       * @returns {undefined}
       */
      $scope.applyUpdatedAtFilter = () => {
        $scope.setUpdatedAtFilter();
        $scope.search.notifyParamChange();
      };

      /**
       * Reset sorting param and run new Search
       *
       * @returns {undefined}
       */
      $scope.resetSortingOptions = () => {
        $scope.search.sorting.reset();
        $scope.search.notifyParamChange();
      };
    };

    /**
     * It force-detects incoming URL sorting options params.
     * If incoming `sorting[field]=updated_at` param is present in the URL, it sets it
     * accordingly.
     *
     * @returns {undefined}
     */
    const runSortingParamsDetection = () => {
      const incomingFilters = qs.parse(window.location.search.substring(1));

      if (
        incomingFilters.sorting &&
        incomingFilters.sorting.field &&
        incomingFilters.sorting.field === $scope.sortingOptions.updatedAtFilterValue
      ) {
        $scope.setUpdatedAtFilter();
      }
    };

    $scope.flipper = devex.flipper;
    $scope.canSeeRecommendedForJobFilter = false;
    $scope.openedNotesId = null;

    /**
     * The property `model` is used as  ng-model for `Recommnended for job` filter, that uses an
     * autocomplete filter. After `$scope.loadJobs` function finishes, this model might be mapped
     * to a job result. Whenever user selects a job, `model` property will be mapped to the job
     * selected. When user leaves the filter blank, `model` property is then `null`.
     */
    $scope.recommendedForJobIdFilter = {
      model: null,
    };

    /**
     * When user chooses a new job to get consultants recommendation, we need to first map
     * the SearchJs value to `recommendedForJobIdFilter.model` model and run a search with new ID.
     * If user removed `recommended_for_job_id` filter (recommendedForJobIdFilter.model will then
     * be null), we need to set the SearchJs value to default so that the `recommended_for_job_id`
     * is removed from search
     *
     * @returns {undefined}
     */
    $scope.notifyRecommendedForJobIdChange = function () {
      $scope.search.filter.recommended_for_job_id.value = $scope.recommendedForJobIdFilter.model
        ? $scope.recommendedForJobIdFilter.model.id
        : null;

      $scope.search.notifyParamChange();
    };

    $scope.browserUrl = devex.urls.BrowserUrl.getInstance();

    /**
     * Add first series of SearchJS filters to the instance that has been created. This batch of
     * filters is more straight-forward as they don't hold any specific logic.
     *
     * @returns {undefined}
     */
    var addSimpleSearchJsFilters = function () {
      $scope.search.addFilter({
        name: 'query',
        isArray: true,
        attachToRoot: true,
      });
      $scope.search.addFilter({
        name: 'has_headline',
      });

      $scope.search.addFilter({
        name: 'recommended_for_job_id',
      });

      var nonRootArrayFilters = [
        'citizenships',
        'locations',
        'locations_experience',
        'languages',
        'education_levels',
        'tag_ids',
      ];

      nonRootArrayFilters.forEach(function setFilter(filterName) {
        $scope.search.addFilter({
          name: filterName,
          isArray: true,
        });
      });

      var falseDefaultFilters = [
        'with_experience_in_monitoring_and_eval',
        'with_managerial_experience',
        'with_business_development_experience',
        'with_experience_in_consulting',
        'with_experience_in_recruitment',
        'with_international_experience',
        'with_eu_experience',
        'with_experience_in_conflict_areas',
        'worked_as_a_usaid_implementer',
        'with_experience_in_dfat',
        'with_experience_in_fcdo',
        'with_experience_in_adb',
        'with_experience_in_afdb',
        'with_experience_in_un',
        'with_experience_in_wb',
        'availability',
        'profiles_with_cv',
      ];

      falseDefaultFilters.forEach(function setFilter(filterName) {
        $scope.search.addFilter({
          name: filterName,
          default: false,
        });
      });

      $scope.search.addFilter({
        name: 'curated_candidate_list_ids',
        isArray: true,
      });
    };

    /**
     * Add more complex SearchJS filters series to existing SearchJs instance
     *
     * @returns {undefined}
     */
    var addComplexSearchJsFilters = function () {
      $scope.search.addFilter({
        name: 'employers',
        isArray: true,
        isActive: function () {
          return this.getValue().length > 0;
        },
        getValue: function () {
          var employers;
          // select employers without time constraint
          employers = _.map(this.value, function (value) {
            return { name: value.name };
          });
          // concat current employers onto employers array (if present)
          if (this.valueCurrent) {
            employers = employers.concat(
              _.map(this.valueCurrent, function (value) {
                return {
                  name: value.name,
                  is_current: true,
                };
              })
            );
          }
          return employers;
        },
        setValue: function (params) {
          let paramsArray = Array.isArray(params) ? params : [params];
          this.value = _.filter(paramsArray, function (value) {
            return !value.is_current;
          });
          this.valueCurrent = _.filter(paramsArray, function (value) {
            return !!value.is_current;
          });
        },
        reset: function () {
          this.value = this.valueCurrent = [];
        },
      });

      $scope.search.addFilter({
        name: 'job_titles',
        default: [],
        isArray: true,
        getValue: function () {
          return _.map(this.value, function (value) {
            return value.name;
          });
        },
        setValue: function (params) {
          var values = Array.isArray(params) ? params : [params];
          this.value = _.map(values, function (val) {
            return { name: val };
          });
        },
      });

      $scope.search.addFilter({
        name: 'experience',
        default: {
          min: 0,
          max: 50,
        },
      });
    };

    /**
     * 2021-05-05: The filter `with_experience_in_dfid` has been renamed to
     * `with_experience_in_fcdo`. Some users might have saved in their
     * browser's bookmarks a URL that contains the former filter Make sure that,
     * when they arrive on the page, we modify their URL to be in sync with the
     * new filter.
     *
     * @returns {undefined}
     */
    const ensureUrlBackwardsCompatibility = () => {
      const incomingFilters = devex.urls.getParams();

      if (incomingFilters?.filter?.with_experience_in_dfid) {
        $scope.search.filter.with_experience_in_fcdo.setValue(true);
      }
    };

    /**
     * @returns {string} - Given incoming tag_ids filter, determine which folders are selected by
     * filtering $scope.tags. Once this is done, join the applied folders' name to produce a string
     */
    $scope.displayAppliedFolderNames = () =>
      $scope.tags
        .filter((tag) => $scope.search?.filter?.tag_ids?.value.includes(tag.id))
        .map((entry) => entry.name)
        .join(' + ');

    /**
     * Create an instance of SearchJS, add filters to it and set callbacks for its events.
     *
     * @returns {undefined}
     */
    var setUpSearchJs = function () {
      $scope.search = new SearchJS({
        searchUrl: Routes.api_consultants_search_path(),
        additionalParams: { highlight: true },
        defaultPageSize: 20,
      });
      $scope.search.on('queryComplete', $scope.queryCompleteCallback);
      $scope.search.on('queryException', $scope.queryExceptionCallback);

      addSimpleSearchJsFilters();
      addComplexSearchJsFilters();
      ensureUrlBackwardsCompatibility();
    };

    /**
     * Request to the BE the user folders, shared folders and also the curated list folders.
     *
     * @returns {undefined}
     */
    const populateUiSelectFolders = () => {
      $http
        .get(tagsPath + createQueryString())
        .then((response) => {
          $scope.tags = [...$scope.tags, ...response.data.data];
        })
        .catch((error) => {
          devex.alerts.showAlert(error.toString(), 'error');
        });
    };

    /**
     * Request to the BE the curated candidate lists
     *
     * @param {boolean} viewCuratedCandidateLists - True if user has permission VIEW_CURATED_LISTS
     *
     * @returns {undefined}
     */
    $scope.setCuratedCandidateLists = (viewCuratedCandidateLists) => {
      if (!viewCuratedCandidateLists) return;

      $http
        .get(curatedListPath + createQueryString({ page: { size: 100 } }))
        .then((response) => {
          $scope.curated_candidate_lists = [
            ...$scope.curated_candidate_lists,
            ...response.data.data,
          ];
        })
        .catch((error) => {
          devex.alerts.showAlert(error.toString(), 'error');
        });
    };

    /**
     * Once `devex.user.getData` returns response (if user is signed in), set up form models of
     * the app, add event listeners, load params from URL, launch first search,
     * etc...
     *
     * @returns {undefined}
     */
    var finishInit = function () {
      $scope.recruiterToolsOptions = {
        noteContentModel: '',
        isNoteFormOpen: false,
        isTagFormOpen: false,
      };

      /**
       * When user clicks on the Back button, BrowserUrl handles all the behavior needed, except
       * for the fact that we have to keep the `recommended_for_job_id`
       * autocomplete filter in sync with the new SearchJs value.
       *
       * @returns {undefined}
       */
      devex.urls.on('popState', function (newValue) {
        if (newValue) {
          if ($scope.search.filter.recommended_for_job_id.isActive()) {
            $scope.recommendedForJobIdModel = $scope.jobs.filter(function (job) {
              return job.id === $scope.search.filter.recommended_for_job_id.value;
            })[0];
          } else {
            $scope.recommendedForJobIdModel = {
              id: null,
            };
          }
        }
      });

      $scope.toggleMoreFilters();
      $scope.search.search();

      if (devex.data.userSignedIn) {
        $scope.getRequestCVRecipients();
        $scope.requestCredits();
        populateUiSelectFolders();
        $scope.loadJobs();
      }
    };

    $scope.onPageChange = function () {
      devex.uiUtils.scrollToTop('pagination-info');
      $scope.search.search();
    };

    $scope.objectify = function (name) {
      return { name: name };
    };

    $scope.personPath = Routes.person_path;

    $scope.queryCompleteCallback = function () {
      $scope.$apply();
      if (devex.data.userSignedIn) {
        $scope.reloadLoggedSearches(5);
        $scope.reloadRequestedCVs();
        $scope.reloadTagFavorites();
        $scope.reloadNotes();
        $scope.reloadMessages();
      }
    };

    $scope.queryExceptionCallback = function (response) {
      if (response.status === 400) {
        $scope.search.reset();
        $scope.search.notifyParamChange();
      }
    };

    $scope.setGetQuery = function (query) {
      if (arguments.length) {
        $scope.search.filter.query.setValue(query);
      } else {
        return $scope.search.filter.query.getValue()[0];
      }
    };

    $scope.setGetSelected = function (value) {
      if (value !== undefined) {
        if (value === true) {
          $scope.selectedResults[this.result.id] = this.result;
        } else {
          delete $scope.selectedResults[this.result.id];
        }
      } else {
        return $scope.isConsultantSelected(this.result);
      }
    };

    $scope.getSelectedConsultantsLength = function () {
      return Object.keys($scope.selectedResults).length;
    };

    /**
     * Checks if the consultant passed as arg is already added to selectedResults
     *
     * @param {object} consultant - Consultant search result
     * @param {number} consultant.id - ID of consultant
     * @returns {boolean} True if consultant is already part of the selection, false if not.
     */
    $scope.isConsultantSelected = function (consultant) {
      var keyAsString = consultant.id.toString();
      return !!$scope.selectedResults[keyAsString];
    };

    /**
     * Sets back selectedResults to its initial state.
     *
     * @returns {undefined} Reset `selectedResults` to an empty object
     */
    $scope.clearSelectedConsultants = function () {
      $scope.selectedResults = {};
    };

    /**
     * Add array of consultants to $scope.selectedResults list
     *
     * @param {Array} searchResults - Array of consultant search results
     * @returns {undefined} Add array of consultants to `selectedResults`
     */
    $scope.addConsultantResultsToSelectedResults = function (searchResults) {
      searchResults.forEach(function (consultant) {
        $scope.selectedResults[consultant.id] = consultant;
      });
    };

    /**
     * When user clicks on a logged search and load corresponding search, applying its params.
     *
     * @param {object} loggedSearch - Previous search as object containing search params
     * @param {object} loggedSearch.params - Search params of previous search, used by SearchJS
     *
     * @returns {undefined}
     */
    $scope.loadLoggedSearch = function (loggedSearch) {
      $scope.search.loadParams(loggedSearch.params);
      $scope.search.search();
    };

    $scope.reloadLoggedSearches = function (limit) {
      LoggedSearch.query(
        {
          search_type: 'consultants',
          'page[size]': limit + 1 || 6,
        },
        function (result) {
          $scope.loggedSearches = result.slice(1);
        }
      );
    };

    $scope.canAccessBulkTools = function () {
      return (
        devex.user.hasPackageViaShortname(['RA']) && !!Object.keys($scope.selectedResults).length
      );
    };

    $scope.requestCV = function (consultant) {
      return $http.post(Routes.api_consultant_request_cv_path({ id: consultant.id })).then(
        function () {
          devex.alerts.showAlert('CV requested successfully!', 'success');
          document
            .getElementById('requestCv-' + consultant.slug_and_id)
            .classList.remove('loading');
          consultant.cvRequested = true;
          $scope.getRequestCVRecipients();
        },
        function () {
          devex.alerts.showAlert('Error occurred! Please try again', 'error');
        }
      ).promise;
    };

    $scope.requestCVClickListener = function ($event, consultant) {
      var requestButtonClass = document.getElementById(
        'requestCv-' + consultant.slug_and_id
      ).classList;
      if (requestButtonClass.contains('loading')) {
        // Return to prevent multiple clicks
        return;
      }
      requestButtonClass.add('loading');
      $event.stopPropagation();
      $event.preventDefault();
      return $scope.requestCV(consultant);
    };

    /**
     * Toggle the more filters dropdown
     *
     * @returns {undefined}
     */
    $scope.toggleMoreFilters = function () {
      var filter = $scope.search.filter;

      if (
        filter.job_titles.isActive() ||
        filter.employers.isActive() ||
        filter.education_levels.isActive()
      ) {
        $('#CollapseAdvanceSearch').collapse();
      }
    };

    $scope.getRequestCVRecipients = function () {
      return $http.get(Routes.api_request_cv_recipients_path()).then(function (response) {
        $scope.requestedCVs = response.data;
        $scope.reloadRequestedCVs();
      });
    };

    $scope.reloadRequestedCVs = function () {
      _.each($scope.requestedCVs, function (requested) {
        var result = _.find($scope.results, function (item) {
          return item.id === requested.consultant_id;
        });
        if (result) {
          result.cvRequested = true;
        }
      });
    };

    /**
     * Toggle tag favorite
     *
     * @param {object} item - Item with a favoriteId prop
     * @returns {undefined}
     */
    $scope.toggleTagFavorite = function (item) {
      if (item.favoriteId) {
        removeTaggings([item.favoriteId]).then(function () {
          $scope.setFavorite(item, null);
          $scope.$apply();
        });
      } else {
        addConsultantTagging(item.id, 'Favorites').then(function (response) {
          $scope.setFavorite(item, response[0].id);
          $scope.$apply();
        });
      }
    };

    $scope.setFavorite = function (element, favoriteId) {
      if (favoriteId) {
        element.is_favorite = true;
        if (typeof favoriteId === 'object') {
          element.favoriteId = favoriteId.id;
        } else {
          element.favoriteId = favoriteId;
        }
      } else {
        element.is_favorite = false;
        element.favoriteId = null;
      }
    };

    $scope.taggableIds = function () {
      _.map($scope.search.results, function (element) {
        return element.id;
      });
    };

    /**
     * Reload tag favorites
     *
     * @returns {Promise} promise - Promise that can be extended using then() callback
     */
    $scope.reloadTagFavorites = function () {
      return queryTaggings($scope.taggableIds()).then(function (response) {
        var favorites = _.filter(response.data, function (element) {
          return element.tag.name === 'Favorites';
        });
        _.map($scope.search.results, function (element) {
          var favorite = _.find(favorites, function (item) {
            return item.taggable_id === element.id;
          });
          $scope.setFavorite(element, favorite);
        });
        $scope.$apply();
      });
    };

    // Notes

    $scope.reloadNotes = function () {
      var params = {
        filter: {
          notable_id: $scope.search.getResultIDs(),
        },
        page: {
          size: 100,
        },
      };

      // reset notes
      _.each($scope.search.results, function (result) {
        result.notes = [];
      });

      // fetch notes
      $http.get(Routes.api_current_user_notes_path(params), params).then(function (response) {
        _.each(response.data.data, function (note) {
          var notesResult = _.find($scope.search.results, function (result) {
            return result.id === note.notable_id;
          });
          if (notesResult) {
            notesResult.notes.push(note);
          }
        });
      });
    };

    // Messages
    $scope.reloadMessages = function () {
      if ($scope.search.results.length > 0) {
        var recipientsIds = [];
        $scope.search.results.forEach(function (element) {
          recipientsIds.push(element.id);
        });
        $http
          .get(
            Routes.api_path('/public/current_user/messages/recipients', {
              consultant_ids: recipientsIds,
            })
          )
          .then(function (response) {
            $scope.recipientsContacted = response.data.data;
          });
      }
    };

    // Tags
    /**
     * Callback that's being called after saving candidates in a foder with the bulk edit
     *
     * @returns {undefined}
     */
    $scope.saveBulkFolderCallback = function () {
      populateUiSelectFolders();
      $scope.recruiterToolsOptions.isTagFormOpen = false;
    };

    // Credits
    /**
     *  Get user's credits via a request
     *
     * @returns {undefined}
     */
    $scope.requestCredits = function () {
      $http.get(Routes.api_current_user_credits_path()).then(function (response) {
        $scope.credits = response.data.credits;
      });
    };

    // Jobs

    /**
     * When user signed in, we run a search on init to get jobs that belongs to user. On success,
     * if SearchJs `recommended_for_job_id` filter is active (meaning its values is different from
     * null), loop through all user's jobs to find which one has to be highlighted by the filter.
     *
     * @returns {undefined}
     */
    $scope.loadJobs = function () {
      var url = Routes.api_jobs_search_path({
        filter: {
          posted_by_my_company: true,
          status: ['active'],
          job_types: [1], // Only `community jobs` have recommendations
        },
        sorting: {
          field: 'updated_at',
        },
        page: {
          size: 300,
        },
        minimal_results: true,
      });

      $http.get(url).then(function (res) {
        var response = res.data;

        $scope.jobs = response.data;

        if ($scope.jobs.length) {
          $scope.canSeeRecommendedForJobFilter = true;
        }

        var filter = $scope.search.filter.recommended_for_job_id;
        if (filter.isActive()) {
          $scope.recommendedForJobIdFilter.model = $scope.jobs.filter(function (job) {
            return job.id === filter.value;
          })[0];
        }
      });
    };

    $scope.toggleFolderSelect = function (id) {
      $scope.openedNotesId = null;

      if ($scope.showFolderSelect === id) {
        $scope.showFolderSelect = null;
      } else {
        $scope.showFolderSelect = id;
      }
    };

    /**
     * Toggles the visibility of a notes section for a specific candidate and it hides the folder
     * section if visible
     *
     * @param {number|undefined} id - ID of the candidate for which toggle a notes section or
     *                                undefined to close them
     *
     * @returns {undefined}
     */
    $scope.toggleNotes = function (id) {
      $scope.showFolderSelect = null;

      if ($scope.openedNotesId === id) {
        $scope.openedNotesId = null;
      } else {
        $scope.openedNotesId = id;
      }
    };

    /**
     * Define some jQuery hacks, needed for the UI
     *
     * @returns {undefined}
     */
    var defineJqueryEventListeners = function () {
      // Hack: UI-select does not work properly if it is hidden on load.
      // This hack runs a scope.$apply() when the controls are shown to wake
      // up ui-select
      $('#CollapseAdvanceSearch').on('shown.bs.collapse', function () {
        $scope.$apply();
      });

      // Delay focus on new saved search text input
      $('#showSaveSearch').on('click', function () {
        $timeout(function () {
          $('#saveSearch').focus();
        }, 100);
      });

      // When new bookmarked search is saved, make My Searches dropdown appear
      $('#bookmarked-search').on('newSearchSaved', function () {
        $('#my-searches').children('.st_dropdown-toggle').dropdown('toggle');
      });
    };

    // Show results from a specific curated candidate list
    $scope.handleSelectCuratedCandidateList = (listId) => {
      $scope.search.filter.curated_candidate_list_ids.setValue(listId);
      $scope.search.search();
      devex.uiUtils.scrollToTop();
    };

    /**
     * Instantiate necessary $scope variables, set up SearchJs, call `devex.user.getData` and then
     * execute callback
     *
     * @returns {undefined}
     */
    this.$onInit = () => {
      /**
       * This function is being triggered via an ng-init helper
       *
       * @param {boolean} isRecruiter - Param to determine if user is a recruiter or not
       * @returns {undefined}
       */
      $scope.setRecruiterStatus = function (isRecruiter) {
        $scope.isRecruiter = isRecruiter;
      };

      $scope.tags = [];
      $scope.curated_candidate_lists = [];
      $scope.credits = { available: 0 };
      $scope.selectedResults = {};
      $scope.results = [];

      setUpSearchJs();
      defineSortingFilterLogic();
      runSortingParamsDetection();
      defineJqueryEventListeners();

      if (devex.data.userSignedIn) {
        devex.user.getData(finishInit);
      } else {
        finishInit();
      }
    };
  },
]);
